import { supabase } from "libs/supabase";
import { FunctionComponent, useContext, useState } from "react";
import LoginImage from "assets/images/image-3.png";
import Button from "components/button";
import { LoadingContext } from "providers/loading";

interface AuthPageProps {}

const AuthPage: FunctionComponent<AuthPageProps> = () => {
  const [email, setEmail] = useState("");
  const { setLoading } = useContext(LoadingContext);
  const [linkSent, setLinkSent] = useState(false);

  const login = async () => {
    setLoading(true);
    await supabase.auth.signInWithOtp({
      email,
      options: {
        emailRedirectTo: window.location.origin,
      },
    });
    setLinkSent(true);
    setLoading(false);
  };

  return (
    <div className="fixed inset-0 flex overflow-auto">
      <div
        className="lg:w-3/5 md:w-1/2 hidden md:block bg-center bg-cover"
        style={{ backgroundImage: `url(${LoginImage})` }}
      ></div>
      <div className="lg:w-2/5 md:w-1/2 w-full flex justify-center items-center sm:px-12 px-7">
        <div className="max-w-[500px] w-full">
          <div className="font-bold text-[36px] mb-6">Login</div>
          <div className="opacity-60 mb-12 text-sm">
            Enter your email address and we'll send you a Magic Link. With just one click, you'll be securely logged in and ready
            to go. No passwords required.
          </div>
          <div className="text-sm mb-2">Your email address</div>
          <input
            className="border rounded outline-none px-4 py-2 block w-full mb-4"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
          ></input>
          <Button className="w-full" onClick={login}>
            Login with Magic link
          </Button>
          {!linkSent ? null : (
            <div className="bg-[#32a040]/10 text-[#44b853] px-4 py-3 rounded-lg mt-4 text-center">
              Magic Link was sent to your email address.
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default AuthPage;
